<svg
  [ngStyle]="styleList"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1.5"
    y="1.5"
    width="61"
    height="61"
    [attr.rx]="rx"
    fill="url(#paint0_linear_1286_1912)"
    stroke="#FEFEFE"
    stroke-width="3"
  />
  <rect
    x="28.5"
    y="14.5"
    width="7"
    height="35"
    rx="3.5"
    fill="url(#paint1_linear_1286_1912)"
    stroke="url(#paint2_linear_1286_1912)"
  />
  <rect
    x="49.5"
    y="28.5"
    width="7"
    height="35"
    rx="3.5"
    transform="rotate(90 49.5 28.5)"
    fill="url(#paint3_linear_1286_1912)"
    stroke="url(#paint4_linear_1286_1912)"
  />
  <defs>
    <linearGradient
      id="paint0_linear_1286_1912"
      x1="37.5"
      y1="64.0004"
      x2="-64.6232"
      y2="47.3419"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="#EBECF7"
      />
    </linearGradient>
    <linearGradient
      id="paint1_linear_1286_1912"
      x1="32"
      y1="14"
      x2="20.6196"
      y2="14.986"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint2_linear_1286_1912"
      x1="34.6471"
      y1="11.2308"
      x2="27.2897"
      y2="12.7443"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="white"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
    <linearGradient
      id="paint3_linear_1286_1912"
      x1="54.4444"
      y1="48.3226"
      x2="50.699"
      y2="69.5375"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint4_linear_1286_1912"
      x1="56.6471"
      y1="25.2308"
      x2="49.2897"
      y2="26.7443"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="white"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
  </defs>
</svg>
